import { LOGO_URL } from "../lib/constants";

const Section = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="text-lg font-semibold text-slate-900 mb-2">{title}</h2>
    <div className="text-sm leading-relaxed text-slate-600 space-y-2">{children}</div>
  </section>
);

export default function Terms() {
  return (
    <div className="min-h-screen bg-slate-50" data-testid="terms-page">
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-3xl mx-auto px-6 py-5 flex items-center gap-3">
          <img src={LOGO_URL} alt="Grian Solar Power" className="h-9 w-auto" data-testid="terms-logo" />
          <span className="font-semibold text-slate-900">Grian Solar Power</span>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold text-slate-900 mb-1">Terms of Service</h1>
        <p className="text-xs text-slate-400 mb-10">Last updated: June 2026</p>

        <Section title="1. About these terms">
          <p>
            These Terms of Service ("Terms") govern your use of the services provided by Grian Solar
            Power (ABN 91 635 362 560) ("we", "us", "our"), including our website, our Facebook and
            Instagram Lead Ad forms, and any enquiry or quote you request from us. By submitting an
            enquiry or engaging with us, you agree to these Terms.
          </p>
        </Section>

        <Section title="2. Our services">
          <p>
            Grian Solar Power provides solar panel and home battery sales, design, quoting and
            installation services to customers in Australia. Any quotes, rebate estimates (including
            STCs and applicable state rebates) and savings figures we provide are estimates only and
            may change based on your site assessment, eligibility, energy usage and prevailing
            government scheme rules at the time of installation.
          </p>
        </Section>

        <Section title="3. Enquiries and lead forms">
          <p>
            When you submit one of our Facebook/Instagram Lead Ad forms or a website enquiry, you
            consent to us contacting you (by phone, SMS or email) about your solar enquiry. The
            information you provide must be accurate and belong to you or someone you are authorised to
            represent.
          </p>
        </Section>

        <Section title="4. Quotes and agreements">
          <p>
            A quote is not a binding contract. Any installation will be subject to a separate written
            agreement, a site inspection, and applicable terms and warranties. Product warranties are
            provided by the relevant manufacturers.
          </p>
        </Section>

        <Section title="5. Your privacy">
          <p>
            We handle your personal information in accordance with our{" "}
            <a href="/privacy" className="text-emerald-600 underline" data-testid="terms-privacy-link">
              Privacy Policy
            </a>. You may request deletion of your information at any time — see our{" "}
            <a href="/data-deletion" className="text-emerald-600 underline" data-testid="terms-data-deletion-link">
              Data Deletion Instructions
            </a>.
          </p>
        </Section>

        <Section title="6. Limitation of liability">
          <p>
            To the extent permitted by law, we are not liable for any indirect or consequential loss
            arising from the use of our website or reliance on estimated figures provided before a
            formal site assessment. Nothing in these Terms excludes any rights you have under the
            Australian Consumer Law.
          </p>
        </Section>

        <Section title="7. Changes to these terms">
          <p>
            We may update these Terms from time to time. The latest version will always be available on
            this page.
          </p>
        </Section>

        <Section title="8. Contact us">
          <p className="font-medium text-slate-800">
            Grian Solar Power<br />
            Website: <a href="https://griansolarpower.com.au" className="text-emerald-600 underline">griansolarpower.com.au</a><br />
            Email: <a href="mailto:info@griansolarpower.com.au" className="text-emerald-600 underline">info@griansolarpower.com.au</a><br />
            Phone: <a href="tel:0485976518" className="text-emerald-600 underline">0485 976 518</a>
          </p>
        </Section>
      </main>

      <footer className="border-t border-slate-200 bg-white">
        <div className="max-w-3xl mx-auto px-6 py-6 text-xs text-slate-400">
          © {new Date().getFullYear()} Grian Solar Power. ABN 91 635 362 560.
        </div>
      </footer>
    </div>
  );
}
